/* eslint-disable */
import { Autocomplete, InputAdornment, TextField } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useMatch } from 'react-router-dom';

import api, { authHeader } from '../../../../services/API/apiConfig';
import { currencyMask } from '../../../styles/util';

import { orderArrayAlphabetically } from '../../../../services/auxiliaryFunctions/functions';
import {
  AutocompleteInputsAutoCompleteComponentStyled,
  AutocompleteInputsStyled,
  BoxModalStyled,
  BtnDeleteFilterStyled,
  BtnFilterStyled,
  CloseModalStyled,
  ContainerButtonsStyled,
  ContainerInputsStyled,
  CustomDivStyled,
  CustomInputDateStyled,
  CustomInputStyled,
  CustomTitleStyled,
  ModalStyled,
  PeriodErrorStyled,
  TextFieldsStyled,
} from './CompositeFilter.styles';

export function CompositeFilter(props) {
  const { open, onClose, getPayables, setActiveFilter, payables } = props;
  const match = useMatch('/constructions/:id/payables');
  const matchClient = useMatch('/constructions-details/:id');

  const user = JSON.parse(localStorage.getItem('user'));

  let id = null;
  if (match) {
    id = parseInt(match.params.id);
  } else if (matchClient) {
    id = parseInt(matchClient.params.id);
  }

  const [due, setDue] = useState(null);
  const [creationDate, setCreationDate] = useState(null);
  const [interval1, setInterval1] = useState(null);
  const [interval2, setInterval2] = useState(null);
  const [lastPayablesNumber, setLastPayablesNumber] = useState(null);
  const [total, setTotal] = useState(null);
  const [valueDisplay, setValueDisplay] = useState(null);
  const [statusId, setStatusId] = useState('3');

  const [suppliers, setSuppliers] = useState([]);
  const [supplierId, setSupplierId] = useState(null);
  const [constructions, setConstructions] = useState([]);
  const [constructionId, setConstructionId] = useState(null);
  const [categories, setCategories] = useState([]);
  const [budgetItems, setBudgetItems] = useState([]);
  const [budgetItemId, setBudgetItemId] = useState('');
  const [budgetItemName, setBudgetItemName] = useState('');
  const [categoryId, setCategoryId] = useState(null);
  const [filter, setFilter] = useState([]);
  const [supplierName, setSupplierName] = useState('');
  const [categoryName, setCategoryName] = useState('');
  const [constructionName, setConstructionName] = useState('');
  const [periodError, setPeriodError] = useState(false);

  const status = [
    { id: '1', status: 'Pago' },
    { id: '0', status: 'Pendente' },
    { id: '3', status: 'Todos' },
  ];
  const lastPayables = [
    { value: '15', title: '15 lançamentos' },
    { value: '30', title: '30 lançamentos' },
    { value: '50', title: '50 lançamentos' },
    { value: '100', title: '100 lançamentos' },
  ];

  function onChangeSupplier(event, value) {
    event.preventDefault();
    if (value !== null) {
      setSupplierId(value.id);
    } else {
      setSupplierId(null);
    }
  }

  function onChangeConstruction(event, value) {
    event.preventDefault();
    if (value !== null) {
      setConstructionId(value.id);
    } else {
      setConstructionId(null);
    }
  }

  function onChangeCategory(event, value) {
    event.preventDefault();
    if (value !== null) {
      setCategoryId(value.id);
    } else {
      setCategoryId(null);
    }
    return;
  }

  function onChangeBudgetItem(event, value) {
    event.preventDefault();
    if (value !== null) {
      setBudgetItemId(value.id);
    } else {
      setBudgetItemId(null);
    }
  }

  useEffect(() => {
    const uniqueSuppliers = payables
      .map(({ supplier }) => supplier)
      .reduce((acc, curr) => ({ ...acc, [curr.id]: curr }), {});

    const orderedSuppliers = orderArrayAlphabetically(
      Object.values(uniqueSuppliers)
    );
    setSuppliers(orderedSuppliers);
  }, [payables]);

  useEffect(() => {
    api.get('/constructions', { headers: authHeader() }).then((res) => {
      const { data } = res.data;
      setConstructions(data.filter(({ finished }) => !finished));
    });
  }, []);

  useEffect(() => {
    api.get('/categories', { headers: authHeader() }).then((res) => {
      const { data } = res.data;
      setCategories(data);
    });
  }, []);

  useEffect(() => {
    if (id || constructionId) {
      api
        .get(`/constructions/${id || constructionId}/budgets`, {
          headers: authHeader(),
        })
        .then((res) => {
          const { data } = res.data;

          function flattenItems(arr, parentNum = '') {
            return arr?.reduce((acc, item, index) => {
                const currentNum = parentNum ? `${parentNum}.${index + 1}` : `${index + 1}`;
                item.item_num = currentNum;

                acc.push(item);

                if (item.items_attributes && item.items_attributes.length > 0) {
                    acc = acc.concat(flattenItems(item.items_attributes, currentNum));
                }

                return acc;
            }, []);
          }
        
          const flattenedArray = flattenItems(data.items_attributes);

          setBudgetItems(flattenedArray);
        });
    }
  }, [id, constructionId]);

  useEffect(() => {
    if (id !== null) {
      api
        .get(`/constructions/${id}/filters`, { headers: authHeader() })
        .then((res) => {
          const { data } = res.data;
          setFilter(data);
          setDue(data.due_date);
          setCreationDate(data.creation_date);
          setLastPayablesNumber(data.last_payables);
          setTotal(data.total);
          setSupplierId(data.supplier);
          setCategoryId(data.category);
          if (data.status === null || data.status === undefined) {
            setStatusId('3');
          } else {
            setStatusId(data.status);
          }

          if (data.date_range !== undefined) {
            if (data.date_range !== null) {
              let interval = Array.from(data.date_range.split(','));
              setInterval1(interval[0]);
              setInterval2(interval[1].trim());
            }
          }
        });
    } else {
      api.get('/filters', { headers: authHeader() }).then((res) => {
        const { data } = res.data;

        setFilter(data);
        setDue(data.due_date);
        setCreationDate(data.creation_date);
        setLastPayablesNumber(data.last_payables);
        setTotal(data.total);
        setStatusId(data.status === null ? '3' : data.status);
        setSupplierId(data.supplier);
        setConstructionId(data.construction);
        setCategoryId(data.category);

        if (data.date_range !== undefined) {
          if (data.date_range !== null) {
            let interval = Array.from(data.date_range.split(','));
            setInterval1(interval[0]);
            setInterval2(interval[1].trim());
          }
        }
      });
    }
  }, []);

  useEffect(() => {
    for (let i = 0; i < suppliers.length; i++) {
      if (suppliers[i].id == supplierId) {
        setSupplierName(suppliers[i].name);
      }
    }
    for (let i = 0; i < constructions.length; i++) {
      if (constructions[i].id == constructionId) {
        setConstructionName(constructions[i].name);
      }
    }
    for (let i = 0; i < categories.length; i++) {
      if (categories[i].id == categoryId) {
        setCategoryName(categories[i].name);
      }
    }
  }, [suppliers, constructions, categories]);

  function changeValueTotal(event) {
    event.preventDefault();
    let { value } = event.target;
    setValueDisplay(value);
    value = value.replace('.', '').replace(',', '.');
    value = String(value);
    setTotal(value);
  }

  async function handleDeleteFilter() {
    setActiveFilter(false);
    setDue('');
    setCreationDate('');
    setInterval1('');
    setInterval2('');
    setLastPayablesNumber(null);
    setValueDisplay('');
    setStatusId('');
    setSupplierName('');
    setConstructionName('');
    setCategoryName('');
    setTotal(null);
    setSupplierId(null);
    setConstructionId(null);
    setCategoryId(null);
    setBudgetItemId('');
    setBudgetItems([]);
    setBudgetItemName('');

    if (filter.id) {
      api
        .delete(`/filters/${filter.id}`, { headers: authHeader() })
        .then((res) => {
          if (res.data.status === 0) {
            setFilter([]);
            getPayables();
          }
        });
    }
  }
  async function onSubmitFilter() {
    let dateRange = null;

    if ((interval1 && !interval2) || (interval2 && !interval1)) {
      setPeriodError(true);
      return;
    }
    if (interval1 && interval2) {
      dateRange = `${interval1}, ${interval2}`;
    }

    const objFilter = {
      filter: {
        due_date: due,
        creation_date: creationDate,
        date_range: dateRange,
        last_payables: lastPayablesNumber,
        total,
        status: statusId !== '3' ? statusId : null,
        supplier: supplierId,
        category: categoryId,
        items: budgetItemId.toString() || null,
      },
    };

    if (id !== null) {
      if (!Object.values(objFilter.filter).every((value) => !value)) {
        await api
          .post(`constructions/${id}/filters`, objFilter, {
            headers: authHeader(),
          })
          .then((res) => {
            const { status } = res.data;

            if (status === 0) {
              setFilter(res.data.data);
              getPayables();
            }
          })
          .catch((err) => console.log(err));
      }
    } else {
      objFilter.filter.constructions = id ? Number(id) : constructionId;

      if (!Object.values(objFilter.filter).every((value) => !value)) {
        await api
          .post('/filters', objFilter, {
            headers: authHeader(),
          })
          .then((res) => {
            const { status } = res.data;
            if (status === 0) {
              setFilter(res.data.data);
              getPayables();
            }
          })
          .catch((err) => console.log(err));
      }
    }

    onClose();
  }

  return (
    <ModalStyled
      open={open}
      onClose={onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <BoxModalStyled id="filter">
        <CloseModalStyled size={24} onClick={onClose} />
        <ContainerInputsStyled>
          <TextFieldsStyled
            fullWidth
            label="Vencimento"
            type="date"
            variant="outlined"
            value={due}
            onChange={(e) => setDue(e.target.value)}
            slotProps={{
              inputLabel: { shrink: true },
            }}
            inputProps={{ maxLength: 10, max: '9999-12-31' }}
          />
          <TextFieldsStyled
            fullWidth
            label="Data de lançamento"
            type="date"
            variant="outlined"
            value={creationDate}
            onChange={(e) => setCreationDate(e.target.value)}
            slotProps={{
              inputLabel: { shrink: true },
            }}
            inputProps={{ maxLength: 10, max: '9999-12-31' }}
          />
          <CustomDivStyled>
            <CustomTitleStyled>Período de vencimento</CustomTitleStyled>
            <CustomInputDateStyled>
              <CustomInputStyled
                type="date"
                value={interval1}
                onChange={(e) => {
                  setPeriodError(false);
                  setInterval1(e.target.value);
                }}
                max="9999-12-31"
              />
              &minus;
              <CustomInputStyled
                type="date"
                value={interval2}
                onChange={(e) => {
                  setPeriodError(false);
                  setInterval2(e.target.value);
                }}
                max="9999-12-31"
              />
            </CustomInputDateStyled>
          </CustomDivStyled>
        </ContainerInputsStyled>
        {periodError && (
          <>
            <PeriodErrorStyled>
              O período deve conter uma data de início e fim.
            </PeriodErrorStyled>
          </>
        )}
        <ContainerInputsStyled>
          <Autocomplete
            fullWidth
            options={lastPayables}
            getOptionLabel={(option) => option.title}
            renderInput={(params) => (
              <TextFieldsStyled
                {...params}
                variant="outlined"
                label="Últimos lançamentos"
                slotProps={{
                  inputLabel: { shrink: true },
                }}
              />
            )}
            value={
              lastPayables.find(
                (payable) => payable.value === lastPayablesNumber
              ) || null
            }
            onChange={(e, newValue) =>
              setLastPayablesNumber(newValue?.value || '')
            }
          />
          <TextField
            label="Valor"
            variant="outlined"
            fullWidth
            slotProps={{
              inputLabel: { shrink: true },
            }}
            value={valueDisplay}
            onChange={(e) => changeValueTotal(currencyMask(e))}
            InputProps={{
              startAdornment: <InputAdornment>R$</InputAdornment>,
            }}
            style={{ minWidth: 180 }}
          />
          <Autocomplete
            fullWidth
            options={categories}
            value={
              categories.find(
                (category) => category.id === categoryId
              ) || null
            }
            onChange={(event, newValue) => onChangeCategory(event, newValue)}
            inputValue={categoryName}
            onInputChange={(event, newInputValue) =>
              setCategoryName(newInputValue)
            }
            getOptionLabel={(options) => options.name || categoryName}
            isOptionEqualToValue={(option, value) => option.id === value.id}
            noOptionsText={'Nenhuma categoria encontrada'}
            sx={{ '.MuiInputBase-input': { height: 23 } }}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Categoria"
                variant="outlined"
                slotProps={{
                  inputLabel: { shrink: true },
                }}
                value={categoryName}
              />
            )}
          />
          <Autocomplete
            options={status}
            getOptionLabel={(option) => option.status}
            value={status.find((st) => st.id === statusId) || null}
            onChange={(e, newValue) => setStatusId(newValue?.id || '')}
            renderInput={(params) => (
              <AutocompleteInputsStyled
                {...params}
                variant="outlined"
                label="Status de pagamento"
                slotProps={{
                  inputLabel: { shrink: true },
                }}
              />
            )}
          />
        </ContainerInputsStyled>
        <ContainerInputsStyled>
          <AutocompleteInputsAutoCompleteComponentStyled
            fullWidth
            options={suppliers}
            value={supplierId}
            onChange={(event, newValue) => onChangeSupplier(event, newValue)}
            inputValue={supplierName}
            onInputChange={(event, newInputValue) =>
              setSupplierName(newInputValue)
            }
            getOptionLabel={(options) => options.name || supplierName}
            isOptionEqualToValue={(option, value) => option.id === value.id}
            noOptionsText={'Nenhum fornecedor encontrado'}
            sx={{ '.MuiInputBase-input': { height: 23 } }}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Fornecedor"
                variant="outlined"
                slotProps={{
                  inputLabel: { shrink: true },
                }}
                value={supplierName}
              />
            )}
          />
          {id === null && (
            <AutocompleteInputsAutoCompleteComponentStyled
              fullWidth
              options={constructions}
              value={constructionId}
              onChange={(event, newValue) =>
                onChangeConstruction(event, newValue)
              }
              inputValue={constructionName}
              onInputChange={(event, newInputValue) =>
                setConstructionName(newInputValue)
              }
              getOptionLabel={(options) => options.name || constructionName}
              isOptionEqualToValue={(option, value) => option.id === value.id}
              noOptionsText={'Nenhuma obra encontrada'}
              sx={{ '.MuiInputBase-input': { height: 23 } }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Obra"
                  variant="outlined"
                  slotProps={{
                    inputLabel: { shrink: true },
                  }}
                  value={constructionName}
                />
              )}
            />
          )}
          <AutocompleteInputsAutoCompleteComponentStyled
            fullWidth
            options={budgetItems || []}
            value={categoryId}
            onChange={(event, newValue) => onChangeBudgetItem(event, newValue)}
            inputValue={budgetItemName}
            onInputChange={(event, newInputValue) =>
              setBudgetItemName(newInputValue)
            }
            getOptionLabel={(option) => `${option.item_num} - ${option.description}`}
            getOptionDisabled={(option) => option.items_attributes.length > 0}
            isOptionEqualToValue={(option, value) => option.id === value.id}
            noOptionsText={'Nenhuma categoria encontrada'}
            sx={{ '.MuiInputBase-input': { height: 23 } }}
            renderInput={(params) => (
              <TextField
                {...params}
                helperText={
                  !constructionId && !id && 'Necessário selecionar uma obra'
                }
                label="Item do orçamento"
                variant="outlined"
                slotProps={{
                  inputLabel: { shrink: true },
                }}
                value={budgetItemName}
              />
            )}
          />
        </ContainerInputsStyled>
        <ContainerButtonsStyled>
          {filter && (
            <BtnDeleteFilterStyled
              variant="outlined"
              color="primary"
              onClick={handleDeleteFilter}
            >
              Limpar filtro
            </BtnDeleteFilterStyled>
          )}
          <BtnFilterStyled onClick={() => onSubmitFilter()}>
            Aplicar filtro
          </BtnFilterStyled>
        </ContainerButtonsStyled>
      </BoxModalStyled>
    </ModalStyled>
  );
}
